/*=========================================================================================
  File Name: moduleDashboardActions.js
  Description: Dashboard Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import Vue from 'vue'
import { Random } from "random-js";
import axios from '@/axios.js'
import con from "@/firebase/firebaseInit.ts";
import Handlebars from 'handlebars';
import AddToCalendar from 'vue-add-to-calendar'
import firebase from 'firebase';
import ls from "@/common/localStorage"

Vue.use(AddToCalendar);
var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');

var PageViewEngagementAPI = con.PageViewCountAPI;
var LoginSummaryAPI = con.LoginSummaryAPI;
var SessionTypeCountAPI = con.SessionTypeCountAPI;
var RoundTableTopicCountAPI = con.RoundTableTopicCountAPI;
var AllOverviewCountAPI = con.AllOverviewCountAPI;
var AllEngagementSummaryCountAPI = con.AllEngagementSummaryCountAPI;
var RegistraionSummaryCountAPI = con.RegistraionSummaryCountAPI;
var FetchAllDashboardStatsAPI = con.FetchAllDashboardStatsAPI;
var MeetingCountAPI = con.MeetingCountAPI;
var MeetingListAPI = con.MeetingListAPI;
var getEventStats = con.getEventStats;
var getTurnoutCounts = con.getTurnoutCounts;
var getExhibitorStats = con.getExhibitorStats;
var getAllRegUseridsAPI = con.getAllRegUseridsAPI;
var getAllActiveUseridsAPI = con.getAllActiveUseridsAPI;
var getAllInactiveUseridsAPI = con.getAllInactiveUseridsAPI;
var getCurrentSessionParticipants = con.getCurrentSessionParticipants;

export default {
    fetchEngagementUrlDetails({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = [];
            const markers1 = [];
            const markers2 = [];
            const markers3 = [];
            var mObj = {};
            var mObj1 = {};
            var mObj2 = {};
            var mObj3 = {};
            var mObj4 = {};
            var mObj5 = {};
            var allPageNames = [];
            var filterdAllPageViews = [];
            var filterdAllPageClicks = [];
            var allExhibitorNames = [];
            var filteredCountsBCExchanged = [];
            var filterdExhibitorDetails = [];

            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numDays": 365
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(AllEngagementSummaryCountAPI, requestData, { headers: headers }).then((response) => {
                response.data.pageAccessCounts.rows.map((row4) => {
                    allPageNames.push(row4.pageName);
                    filterdAllPageViews.push(row4.viewCount);
                    filterdAllPageClicks.push(row4.clickCount);

                });

                mObj.options = {
                    "grid": { "borderColor": "#ebebeb", "padding": { "left": 0, "right": 0 } }, "legend": { "show": false }, "dataLabels": { "enabled": false }, "chart": { "stacked": true, "type": "bar", "toolbar": { "show": false } }, "colors": ["#4c8af6", "#EA5455"], "plotOptions": { "bar": { "columnWidth": "10%" } }, "xaxis": { "labels": { "style": { "cssClass": "text-grey fill-current" } }, "axisTicks": { "show": false }, "categories": allPageNames, "axisBorder": { "show": false }, "convertedCatToNumeric": false }, "yaxis": {
                        "tickAmount": 5, "labels": {
                            "style": { "cssClass": "text-grey fill-current" }, "formatter": function (val) {
                                return val.toFixed(0);
                            }
                        }
                    }, "tooltip": { "x": { "show": false } }
                }
                markers.push(mObj);
                mObj1.name = "Views";
                mObj1.data = filterdAllPageViews;

                mObj2.name = "Clicks";
                mObj2.data = filterdAllPageClicks;

                if (response.data.boothAccessCounts.grandTotal.clicks > 0) {
                    response.data.boothAccessCounts.rows.map((row4) => {
                        filteredCountsBCExchanged.push(row4.totCount);
                        allExhibitorNames.push(row4.boothName);
                        filterdExhibitorDetails.push(row4.clicks);
                    });
                }

                mObj3.name = "Clicks";
                mObj3.data = filterdExhibitorDetails;

                mObj4.name = "Business Card Exchange";
                mObj4.data = filteredCountsBCExchanged;

                mObj5.options = {
                    "colors": ["#4c8af6", "#008080", "#EA5455", "#FF9F43", "#1E1E1E"], "plotOptions": { "bar": { "horizontal": false, "endingShape": "rounded", "columnWidth": "55%" } }, "dataLabels": { "enabled": false }, "stroke": { "show": true, "width": 2, "colors": ["transparent"] }, "xaxis": { "categories": allExhibitorNames }, "yaxis": {
                        "tickAmount": 5, "labels": {
                            "style": { "cssClass": "text-grey fill-current" }, "formatter": function (val) {
                                return val.toFixed(0);
                            }
                        }
                    }, "fill": { "opacity": 1 }, "tooltip": { "y": {} }, "legend": { "show": false, }
                };
                markers1.push(mObj1);
                markers1.push(mObj2);
                markers2.push(mObj3);
                markers2.push(mObj4);
                markers3.push(mObj5);
                resolve({ status: 200, data: markers, data1: markers1, data2: markers2, data3: markers3 })

            }).catch((error) => {
                console.log('Error fetching registration count==:', error)
            })

        })

    },
    fetchRegistrationCountDetails({ commit }, lastDays = 7) {
        debugger;
        return new Promise((resolve, reject) => {
            var mObj = {};
            var mObj1 = {};
            var mObj2 = {};
            var mObj3 = {};
            var mObj4 = {};
            let markers = [];
            let markers1 = [];
            let markers2 = [];
            let markers3 = [];
            let markers4 = [];
            let filteredCountryList = [];
            let filterdAllCountryRegistrations = [];
            let filteredDeviceList = [];
            let filterdAllDeviceRegistrations = [];
            let filteredTypeList = [];
            let filterdAllTypeRegistrations = [];
            let filteredDateList = [];
            let filterdAllDateRegistrations = [];
            let filteredRegTypeList = [];
            let filterdAllRegTypeRegistrations = [];
            let filteredRegTypeTotCount = [];
            let filteredRegTypeTotAmount = [];

            let UnknowCounts = 0;

            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numDays": lastDays
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(RegistraionSummaryCountAPI, requestData, { headers: headers }).then((response) => {
                mObj.TotalRegistrations = response.data.totalRegCount;
                mObj.data = [0, 0, 0, 0, 0, 0];
                mObj.name = "Registered";
                mObj.colors = ['#54ea86', '#54ea86', '#54ea86', '#54ea86', '#54ea86', '#54ea86'];                
                response.data.byType.map((row4) => {
                    if (row4.formName && row4.formName.toLowerCase() == "free") {
                        mObj.freecount = row4.regCount;
                    } else if (row4.formName && row4.formName.toLowerCase() == "paid") {
                        mObj.paidcount = row4.regCount;
                    } else {
                        mObj.unpaidcount = row4.regCount;
                    }
                    if(row4.formName){
                        filteredTypeList.push(row4.formName)
                        filterdAllTypeRegistrations.push(row4.regCount);
                    }else {
                        UnknowCounts += row4.regCount;
                    }
                });
                if(UnknowCounts){
                    filteredTypeList.push("Unknown")
                    filterdAllTypeRegistrations.push(UnknowCounts);
                }
                mObj.data = { "labels": filteredTypeList, "datasets": [{ "label": "Registered From", "backgroundColor": ["#4c8af6", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#7961F9", "#4ca1af", "#141e30", "#56ab2f", "#cc2b5e"], "data": filterdAllTypeRegistrations }] };
                mObj.options = { "legend": { "display": false }, "title": { "display": false, "text": "Predicted world population (millions) in 2050" } };
                mObj.formtypeFlg = filteredTypeList.length > 0 ? true : false;
                markers1.push(mObj);

                response.data.byCountry.map((row4) => {
                    if (row4.country == "{unknown}") {
                        filteredCountryList.push("Other");
                        filterdAllCountryRegistrations.push(row4.regCount);
                    } else {
                        filteredCountryList.push(row4.country)
                        filterdAllCountryRegistrations.push(row4.regCount)
                    }
                });

                mObj1.data = { "labels": filteredCountryList, "datasets": [{ "label": "Registered From", "backgroundColor": ["#4c8af6", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#7961F9", "#4ca1af", "#141e30", "#56ab2f", "#cc2b5e"], "data": filterdAllCountryRegistrations }] };
                mObj1.options = { "legend": { "display": false }, "title": { "display": false, "text": "Predicted world population (millions) in 2050" } };
                mObj1.countryFlg = filteredCountryList.length > 0 ? true : false;
                markers.push(mObj1);

                response.data.byOs.map((row4) => {
                    if (row4.os == "{unknown}") {
                        filteredDeviceList.push("Other");
                        filterdAllDeviceRegistrations.push(row4.regCount);
                    } else {
                        filteredDeviceList.push(row4.os)
                        filterdAllDeviceRegistrations.push(row4.regCount);
                    }
                });

                mObj2.data = { "labels": filteredDeviceList, "datasets": [{ "label": "Registered From", "backgroundColor": ["#4c8af6", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E", "#7961F9", "#4ca1af", "#141e30", "#56ab2f", "#cc2b5e"], "data": filterdAllDeviceRegistrations }] };
                mObj2.options = { "legend": { "display": false }, "title": { "display": false, "text": "Predicted world population (millions) in 2050" } };
                mObj2.deviceFlg = filteredDeviceList.length > 0 ? true : false;
                markers2.push(mObj2);

                let DatebackgroundColor = [];
                response.data.byDate.map((row4) => {                    
                    filteredDateList.push(row4.regDate ? row4.regDate : 'Unknown')
                    filterdAllDateRegistrations.push(row4.regCount);
                    DatebackgroundColor.push('#4c8af6');
                });

                mObj3.data = { "labels": filteredDateList, "datasets": [{ "label": "Registered From", "backgroundColor": DatebackgroundColor, "data": filterdAllDateRegistrations }] };
                mObj3.options = { "legend": { "display": false }, "title": { "display": false, "text": "Predicted world population (millions) in 2050" } };
                mObj3.dateFlg = filteredDateList.length > 0 ? true : false;
                markers3.push(mObj3);

                UnknowCounts = 0;
                response.data.byRegType.map((row4) => { 
                    if(row4.regType){
                        filteredRegTypeList.push(row4.regType)
                        filterdAllRegTypeRegistrations.push(row4.regCount);
                        filteredRegTypeTotCount.push(row4.regCount);
                        filteredRegTypeTotAmount.push(row4.totAmount);
                    }else {
                        UnknowCounts += row4.regCount;
                    }                   
                    
                });
                if(UnknowCounts){
                    filteredRegTypeList.push("Unknown")
                    filterdAllRegTypeRegistrations.push(UnknowCounts);
                    filteredRegTypeTotCount.push(0);
                    filteredRegTypeTotAmount.push(0);
                }

                let filteredRegTypeSeries = [
                    {
                        name: 'Total Count',
                        data: filteredRegTypeTotCount
                    },
                    {
                        name: 'Total Amount',
                        data: filteredRegTypeTotAmount
                    }
                ]

                mObj4.data = { "labels": filteredRegTypeList, "datasets": [{ "label": "Total Count", "data": filterdAllRegTypeRegistrations }] };
                mObj4.series = filteredRegTypeSeries;
                //mObj4.options = { "legend": { "display": false }, "title": { "display": false, "text": "Predicted world population (millions) in 2050" } };
                mObj4.options = { labels: filteredRegTypeList,chart: { type: 'bar', stacked: true, toolbar: { show: true }, zoom: {enabled: true }}, plotOptions: { bar: { horizontal: false, borderRadius: 10 },} ,xaxis: {type: 'category', categories: filteredRegTypeList}, legend: { position: 'right', offsetY: 40 },   }
                mObj4.regtypeFlg = filteredRegTypeList.length > 0 ? true : false;
                markers4.push(mObj4);

                resolve({ status: 200, data: markers1, data1: markers, data2: markers2, data3: markers3, data4: markers4 })
            }).catch((error) => {
                console.log('Error fetching registration count==:', error)
            })

        })
    },
    fetchRoundTablesCount({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            var roundtableCounts = [];
            var roundtableTopicNames = [];
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(RoundTableTopicCountAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    roundtableCounts.push(row4.totalCount)
                    roundtableTopicNames.push(row4.topicName)
                });
                mObj.count = response.data.grandTotal;
                mObj.data = roundtableCounts;
                mObj.options = { "labels": roundtableTopicNames, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "type": "pie", "offsetY": 0, "dropShadow": { "enabled": false, "blur": 5, "left": 1, "top": 1, "opacity": 0.2 }, "toolbar": { "show": false } }, "stroke": { "width": 5 }, "colors": ["#7961F9", "#FF9F43", "#EA5455", "#ea54d3", "#54eaea", "#54ea86", "#cc2b5e", "#56ab2f", "#141e30", "#4ca1af "], "fill": { "type": "gradient", "gradient": { "gradientToColors": ["#9c8cfc", "#FFC085", "#f29292", "#f39be5", "#9bf3f3", "#9bf3b8", "#753a88", "#a8e063", " #243b55", "#c4e0e5"] } } };
                markers.push(mObj);
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching roundtable count==:', error)
            })

        })
    },
    fetchSessionCount({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            var sessionCounts = [];
            var sessionNames = [];
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(SessionTypeCountAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    sessionCounts.push(row4.totalCount)
                    sessionNames.push(row4.typeName)
                });
                mObj.count = response.data.grandTotal;
                mObj.data = sessionCounts;
                mObj.options = { "labels": sessionNames, "dataLabels": { "enabled": false }, "legend": { "show": false }, "chart": { "offsetY": 30, "type": "donut", "toolbar": { "show": false } }, "stroke": { "width": 0 }, "colors": ["#7961F9", "#FF9F43", "#EA5455", "#ea54d3", "#54eaea", "#54ea86"], "fill": { "type": "gradient", "gradient": { "gradientToColors": ["#9c8cfc", "#FFC085", "#f29292", "#f39be5", "#9bf3f3", "#9bf3b8"] } } }
                mObj.name = "Session";
                markers.push(mObj);
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching session count==:', error)
            })

        })
    },
    fetchAllEntityCount({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            const markers1 = []
            const box1 = []
            var mObj1 = {};
            var mObj2 = {};
            var mObj3 = {};
            var mObj4 = {};
            var turnout = {};
            var total = [];
            var totalLoginToday;
            var totalPercentage;
            var totalAttendees;
            var totalCount;
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(AllOverviewCountAPI, requestData, { headers: headers }).then((response) => {

                mObj1.orderType = "Attendees";
                mObj1.counts = response.data.attendeeCount;
                mObj1.color = "primary";
                totalAttendees = response.data.attendeeCount;
                markers.push(mObj1);
                markers1.push(response.data.attendeeCount);

                mObj3.orderType = "Speakers";
                mObj3.counts = response.data.speakerCount;
                mObj3.color = "danger";
                markers.push(mObj3);
                markers1.push(response.data.speakerCount);

                mObj4.orderType = "Sponsors";
                mObj4.counts = response.data.sponsorCount;
                mObj4.color = "success";
                markers.push(mObj4);
                markers1.push(response.data.sponsorCount);

                mObj2.orderType = "Exhibitors";
                mObj2.counts = response.data.exhibitorCount;
                mObj2.color = "warning";
                markers.push(mObj2);
                markers1.push(response.data.exhibitorCount);

                totalLoginToday = response.data.loginCount;
                if (totalAttendees > 0) {
                    totalPercentage = ((100 * totalLoginToday) / totalAttendees).toFixed(2)
                } else {
                    totalPercentage = 0
                }
                turnout.totalLoginToday = totalLoginToday;
                turnout.totalAttendees = totalAttendees;
                turnout.totalPercentage = totalPercentage;
                totalCount = response.data.attendeeCount + response.data.speakerCount + response.data.sponsorCount + response.data.exhibitorCount;
                total.push(totalCount);
                var options = { "labels": ["Attendees", "Speakers", "Sponsors", "Exhibitors"], "plotOptions": { "radialBar": { "size": 165, "offsetY": -5, "hollow": { "size": "20%" }, "track": { "background": "#ebebeb", "strokeWidth": "100%", "margin": 15 }, "dataLabels": { "show": true, "name": { "fontSize": "18px" }, "value": { "fontSize": "16px", "color": "#636a71", "offsetY": 11, "formatter": function (val) { return val } }, "total": { "show": true, "label": "Total", formatter() { return total[0] } } } } }, "responsive": [{ "breakpoint": 576, "options": { "plotOptions": { "radialBar": { "size": 150, "hollow": { "size": "20%" }, "track": { "background": "#ebebeb", "strokeWidth": "100%", "margin": 15 } } } } }], "colors": ["#7961F9", "#FF9F43", "#EA5455", "#54ea86"], "fill": { "type": "gradient", "gradient": { "shade": "dark", "type": "vertical", "shadeIntensity": 0.5, "gradientToColors": ["#9c8cfc", "#FFC085", "#f29292", "#9bf3b8"], "inverseColors": false, "opacityFrom": 1, "opacityTo": 1, "stops": [0, 100] } }, "stroke": { "lineCap": "round" }, "chart": { "height": 355, "dropShadow": { "enabled": true, "blur": 3, "left": 1, "top": 1, "opacity": 0.1 } } };

                resolve({ status: 200, data: markers, data1: markers1, options: options, turnout: turnout })

            }).catch((error) => {
                console.log('Error fetching all overview count==:', error)
            })

        })
    },
    fetchLast7DaysEngagementCount({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            var individualAttendeeCountPrDay = [];
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(PageViewEngagementAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    individualAttendeeCountPrDay.push(row4.accessCount)

                });
                mObj.count = response.data.grandTotal;
                mObj.data = individualAttendeeCountPrDay;
                mObj.name = "Views";
                markers.push(mObj);
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching 7 day engagement==:', error)
            })

        })
    },
    fetchLoginTypCount({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            var mObj1 = {};
            var mObj2 = {};

            var finalNormalLoginCountPerDay = [];
            var finalGoogleLoginCountPerDay = [];
            var dateRange = [];
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numDays": 365
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(LoginSummaryAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    dateRange.push(row4.loginDate);
                    finalNormalLoginCountPerDay.push(row4.totalLoginCount.normal)
                    finalGoogleLoginCountPerDay.push(row4.totalLoginCount.google)
                });
                mObj1.name = "Normal Login";
                mObj1.data = finalNormalLoginCountPerDay;
                mObj1.sum = response.data.grandTotal.normal;

                mObj2.name = "Google Login";
                mObj2.data = finalGoogleLoginCountPerDay;
                mObj2.sum = response.data.grandTotal.google;

                var options = {
                    "chart": { "toolbar": { "show": false }, "dropShadow": { "enabled": true, "top": 5, "left": 0, "blur": 4, "opacity": 0.1 } }, "stroke": { "curve": "smooth", "dashArray": [0, 8], "width": [4, 2] }, "grid": { "borderColor": "#e7e7e7" }, "legend": { "show": false }, "colors": ["#F97794", "#b8c2cc"], "fill": { "type": "gradient", "gradient": { "shade": "dark", "inverseColors": false, "gradientToColors": ["#4c8af6", "#b8c2cc"], "shadeIntensity": 1, "type": "horizontal", "opacityFrom": 1, "opacityTo": 1, "stops": [0, 100, 100, 100] } }, "markers": { "size": 0, "hover": { "size": 5 } }, "xaxis": { "labels": { "style": { "cssClass": "text-grey fill-current" } }, "axisTicks": { "show": false }, "categories": dateRange, "axisBorder": { "show": false }, "convertedCatToNumeric": true }, "yaxis": {
                        "tickAmount": 5, "labels": {
                            "style": { "cssClass": "text-grey fill-current" }, "formatter": function (val) {
                                return val.toFixed(0);
                            }
                        }
                    }, "tooltip": { "x": { "show": false } }
                }
                markers.push(mObj1);
                markers.push(mObj2);
                resolve({ status: 200, data: markers, options: options })
            }).catch((error) => {
                console.log('Error fetching 30 days login summary count==:', error)
            })

        })
    },
    getFirebaseAccessToken(context) {
        return new Promise((resolve, reject) => {
            let accessToken = ls.getSessionValueByKey("Session_AccessToken")
            resolve(accessToken);
        })
    },
    fetchAllDashboardStats(context) {
        return new Promise((resolve, reject) => {
            const markers = [];
            var mObj = {};


            // var totalMeetingCount = 0;
            // context.dispatch('getFirebaseAccessToken').then(accessToken => {
            //     const headers = {
            //         'Authorization': `Bearer ${accessToken}`,
            //         "Content-Type": "application/json"
            //     }

            //     var requestData = {
            //         "key": {
            //             "instanceId": "OA_UAT",
            //             "clientId": Session_Client_Id,
            //             "eventId": Session_Event_Id,
            //         }
            //     }

            //     axios.put(MeetingListAPI, requestData, { headers: headers }).then((response) => {
            //         if(response.data.result != undefined){
            //             let Accepted = response.data.result.Accepted
            //             let Canceled = response.data.result.Canceled
            //             let Pending = response.data.result.Pending
            //             let Rejected = response.data.result.Rejected
            //             totalMeetingCount = Accepted.length + Canceled.length + Pending.length + Rejected.length;
            //         }else{
            //             totalMeetingCount = 0;
            //         }
            //     }).catch(err => { console.log(err); resolve([]) })
            // })



            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours" : 200000
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(FetchAllDashboardStatsAPI, requestData, { headers: headers }).then((response) => {
                mObj.roundTableCount = response.data.countsByRtTopic.grandTotal;
                mObj.sessionCounts = response.data.countsBySessionType.grandTotal;
                mObj.attendeeCount = response.data.countsOverview.attendeeCount;
                mObj.exhibitorCount = response.data.countsOverview.exhibitorCount;
                mObj.speakerCount = response.data.countsOverview.speakerCount;
                mObj.sponsorCount = response.data.countsOverview.sponsorCount;
                mObj.meetingCount = response.data.meetingSummary.result.totCount;

                markers.push(mObj);
                resolve({ status: 200, data: markers })

            }).catch((error) => {
                console.log('Error fetching all dashboard stats count==:', error)
            })

        })

    },

    fetchMeetingCount({ commit }) {
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            var dateRange = [];
            var accepted = [];
            var cancelled = [];
            var pending = [];

            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(MeetingCountAPI, requestData, { headers: headers }).then((response) => {
                if(response.data.rows){
                    response.data.rows.map((row4) => {
                        dateRange.push(row4.createDate);
                        accepted.push(row4.countAccepted);
                        cancelled.push(row4.countCancelled);
                        pending.push(row4.countPending);
                    });
                }
                mObj.count = response.data.grandTotal;
                mObj.data = [{
                    name: 'Accepted',
                    data: accepted
                }, {
                    name: 'Cancelled',
                    data: cancelled
                }, {
                    name: 'Pending',
                    data: pending
                }]
                mObj.options = {
                    colors: ['#4c8af6', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
                    plotOptions: {
                        bar: {
                            horizontal: false,
                            endingShape: 'rounded',
                            columnWidth: '55%',
                        },
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        show: true,
                        width: 2,
                        colors: ['transparent']
                    },

                    xaxis: {
                        categories: dateRange,
                    },
                    yaxis: {
                        title: {
                            text: ''
                        }
                    },
                    fill: {
                        opacity: 1

                    },
                    chart: {
                        toolbar: {
                            show: false
                        }
                    }
                }
                markers.push(mObj);
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching meeting count==:', error)
            })

        })
    },
    getEventStats(context) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "numDays": 365
            }

            axios.post(getEventStats, requestData, { headers: headers }).then(response => {
                //console.log(response.data)
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getExhibitorStats(context, filterval) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "numHours": Number(filterval)*24
            }

            axios.post(getExhibitorStats, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getTurnoutCounts(context, filterval) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "numHours": Number(filterval)
            }

            axios.post(getTurnoutCounts, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getAllRegisteredUsers(){
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT"
            }

            axios.post(getAllRegUseridsAPI, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getAllActiveUsers(context, filterval){
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "numHours": Number(filterval)
            }

            axios.post(getAllActiveUseridsAPI, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getAllInactiveUsers(context, filterval){
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "numHours": Number(filterval)
            }

            axios.post(getAllInactiveUseridsAPI, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getCurrentSessionParticipants(){
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT"
            }

            axios.post(getCurrentSessionParticipants, requestData, { headers: headers }).then(response => {
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    }
}

